import { formatPrice } from 'utils/format';
import { claimLabel } from './coupon';
import { normalizePromoCode } from './orderPriceRequest';

export const quotePromo = (quote, code) => {
  const promo = quote?.presentation?.bag?.promo;
  return normalizePromoCode(code) && normalizePromoCode(promo?.code) === normalizePromoCode(code)
    ? promo
    : null;
};

export const couponVerdict = (claimedCoupon, quote) => {
  const { code, status, summary, message, coveredProductNames, coversCart } = claimedCoupon;
  if (code && quote?.rejectedPromoCode === normalizePromoCode(code)) {
    return { tone: 'body', text: `${code} could not be found. You can continue without a promo code.` };
  }
  if (code && quote?.excludedPromoCode === normalizePromoCode(code)) {
    return { tone: 'body', text: `${code} does not apply to the products in your cart.` };
  }
  const promo = quotePromo(quote, code);
  if (promo) {
    if (promo.status === 'applied') {
      if (Number(promo.discount) > 0) {
        const saving = formatPrice(Number(promo.discount), quote.currency);
        return { tone: 'success', text: `You save ${saving} with ${code}.` };
      }
      if (promo.free_shipping) {
        return { tone: 'success', text: `Free shipping with ${code}.` };
      }
    }
    if (promo.status === 'below_minimum') {
      return {
        tone: 'body',
        text: `Add ${formatPrice(Number(promo.missing_amount), quote.currency)} more to use ${code}.`,
      };
    }
    if (promo.status === 'quantity_exceeded') {
      return { tone: 'body', text: `${code}: The quantity limit for this coupon has been exceeded.` };
    }
    if (promo.status === 'not_eligible' || promo.status === 'no_discount') {
      return { tone: 'body', text: `${code} does not apply to this order.` };
    }
  }
  if (status === 'invalid') return { tone: 'danger', text: message };
  if (summary) {
    const offer = `${code}: ${claimLabel(summary, coveredProductNames)}.`;
    return {
      tone: 'body',
      text: coversCart ? offer : `${offer} Nothing in your cart qualifies yet.`,
    };
  }
  return { tone: 'body', text: `You’re applying ${code} promo code.` };
};
